<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <div class="breadcrumbactive">
                        <div>
                            <span>Sales</span>
                            <span><router-link to="/campaign/sms/campaignSmsListView/" class="text-white pl-2 text-line">Campaign</router-link></span>
                            <div>{{campaign_name || '-'}}</div>
                        </div>
                    </div>
                    <div v-if="campaign_status && this.loggedInUser.user_role == 'sales_manager'">
                        <span class="fs-16 text-capitalize"
                        :class="{
                            'text-pending':campaign_info.status == 'pending',
                            'text-approved':campaign_info.status == 'approved',
                            'text-rejected':campaign_info.status == 'rejected'}"
                        >Status : {{campaign_status}}</span>
                    </div>
                </div>
            </h2>
            <div v-if="callInProgress" class="d-flex justify-content-center pt-2">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
            </div>
            <div v-else class="row">
                <div class="col-lg-8 col-md-12 col-sm-12">
                    <div class="bg-white box-radius">
                        <div class="sub-heading pb-3">
                            <!-- <p class="whitespace-nowrap">{{campaign_info.name + ' Info'}}</p> -->
                            <div class="d-flex">
                                <span>
                                    {{campaign_info.name + ' Info'}}
                                </span>
                                <span>
                                    <sup>
                                        <el-dropdown style="width:200px">
                                            <span class="el-dropdown-link">
                                                <img src="/static/images/info_icon.svg" width="15" class="ml-2" alt="">
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <div class="p-3">
                                                    <div class="text-secondary fs-13">{{campaign_info.name + ' Info'}}</div>
                                                    <div class="fs-13 pt-3">Campaign Name  :  {{campaign_info.name}}</div>
                                                    <div class="fs-13 pt-1">Author Name  : {{campaign_info.author_name}}</div>
                                                    <div class="fs-13 pt-1 pb-3">Industry Name  : {{campaign_info.industry_type}}</div>

                                                    <div style="border-bottom: 1px solid #92b9dc;width:100%"></div>

                                                    <div class="fs-13 pt-3">Start Date & Time  : {{campaign_info.start_date}} {{campaign_info.start_time}}</div>
                                                    <div class="fs-13 pt-1 pb-3">End Date & Time  : {{campaign_info.end_date}} {{campaign_info.end_time}}</div>

                                                    <div style="border-bottom: 1px solid #92b9dc;width:100%"></div>

                                                    <div class="fs-13 pt-3 pb-3">Budget : {{campaign_info.budget.symbol}} {{campaign_info.budget.value || '-'}}</div>

                                                    <div style="border-bottom: 1px solid #92b9dc;width:100%"></div>

                                                    <div class="fs-13 pt-3">Sent SMS Volume : {{analytics_data.total.delivered}}</div>
                                                    <div class="fs-13 pt-1 pb-3">Description : {{campaign_info.description || '-'}}</div>
                                                </div>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </sup>
                                </span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between p-6">
                            <p class="text-color fw-500">Data Analysis</p>
                            <p class="fw-500">Sent SMS Volume : {{analytics_data.total.delivered}}</p>
                        </div>
                        <div class="px-4">
                            <table class="table table-responsive table-responsive-custom p-4">
                                <tbody class="email-table">
                                    <tr>
                                        <td class="border-right today-col fw-500 cstm-width text-center" rowspan="2">Today's Update</td>
                                        <!-- <td class="w-1 whiteSpace border-right fw-500">Opens</td> -->
                                        <td class="whiteSpace border-right fw-500 cstm-width text-center">Delivered</td>
                                        <td class="whiteSpace border-right fw-500 cstm-width text-center">Failed</td>
                                        <!-- <td class="w-1 whiteSpace border-right fw-500">Clicks</td>
                                        <td class="whiteSpace border-right fw-500">Unique Clicks</td>
                                        <td class="w-1 whiteSpace border-right fw-500">Spam Reports</td> -->
                                    </tr>
                                    <tr>
                                        <!-- <td class="border-right">{{analytics_data.today.opens}}</td> -->
                                        <td class="border-right text-center">{{analytics_data.today.delivered}}</td>
                                        <td class="border-right text-center">{{analytics_data.today.failed}}</td>
                                        <!-- <td class="border-right">{{analytics_data.today.clicks}}</td>
                                        <td class="border-right">{{analytics_data.today.unique_clicks}}</td>
                                        <td class="border-right">{{analytics_data.today.spam_reports}}</td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div  style="height:259px;margin-bottom:12px">
                            <table class="email-details-table table table-responsive p-4">
                                <thead>
                                    <th class="col-width text-color">Parameters</th>
                                    <th class="col-width text-color">Total</th>
                                    <th class="col-width text-color">Today</th>
                                    <th class="col-width text-color">Previous Day</th>
                                    <th class="col-width text-color">Previous Week</th>
                                    <th class="col-width text-color">Previous Month</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Sent</td>
                                        <td>{{analytics_data.total.sent}}</td>
                                        <td>{{analytics_data.today.sent}}</td>
                                        <td>{{analytics_data.previous_day.sent}}</td>
                                        <td>{{analytics_data.previous_week.sent}}</td>
                                        <td>{{analytics_data.previous_month.sent}}</td>
                                    </tr>
                                    <tr>
                                        <td>Delivered</td>
                                        <td>{{analytics_data.total.delivered}}</td>
                                        <td>{{analytics_data.today.delivered}}</td>
                                        <td>{{analytics_data.previous_day.delivered}}</td>
                                        <td>{{analytics_data.previous_week.delivered}}</td>
                                        <td>{{analytics_data.previous_month.delivered}}</td>
                                    </tr>
                                    <tr>
                                        <td>Failed</td>
                                        <td>{{analytics_data.total.failed}}</td>
                                        <td>{{analytics_data.today.failed}}</td>
                                        <td>{{analytics_data.previous_day.failed}}</td>
                                        <td>{{analytics_data.previous_week.failed}}</td>
                                        <td>{{analytics_data.previous_month.failed}}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12 col-sm-12">
                    <div class="bg-white box-radius pb-6">
                        <div class="sub-heading pb-3">
                            <span class="fw-500">Notes</span>
                            <span class="pr-6 fs-18 fw-500 pointer float-right" @click="addNotes(null)">+</span>
                        </div>
                        <div class="pb-2 notes-div">
                            <div v-if="campaign_info.notes.length == 0 && loader" class="d-flex justify-content-center pt-2">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                            </div>
                            <div class="no-data pt-2" v-else-if="campaign_info.notes.length == 0 && !loader">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/add_notes.svg">
                                    <div>There are no Notes Added<br>Please click the plus button to add notes</div>
                            </div>
                            <div v-else>
                                    <div v-for="(note,note_index) in campaign_info.notes" :key="note_index"
                                        class="d-flex flex-column p-2 mt-2 mx-4 bordrad-5px"
                                        style="box-shadow: 0 0 6px 0 #939393;">
                                        <div class="d-flex justify-content-between">
                                            <div class="overflowing-text" style="width:353px;">
                                                <span class="fs-12 text-flow">{{note.note}}</span>
                                            </div>
                                            <div class="d-flex">
                                                <i class="icon icon-pencil fs-20 pointer text-dark-blue" @click="addNotes(note_index)"></i>
                                                <i class="icon icon-trash fs-20 pointer text-dark-blue ml-2" @click="deleteNotes(note_index)"></i>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-white box-radius mt-3 pb-4">
                        <h6 class="text-color fw-500 pt-5 pl-4">Attachments</h6>
                        <div class="overflow-auto mx-ht mt-3">
                            <div class="attachments-section text-center pt-2 pb-1">
                                <img src="/static/images/multimedia.svg" style="width:20px;" alt="">
                                Drag and drop your files here or
                                <file-upload class="choose-file btn fw-500 pl-0 pr-0 pointer"
                                    :multiple="true" :disabled="attachments.length >= 10"
                                    :class="{'block-cursor': attachments.length >= 10}"
                                    :drop="true" :drop-directory="true"
                                    accept=".jpg, .png, .pdf, .docx, .txt, .gif, .jpeg, .xls, .xlsx, .csv, .eml"
                                    @input-file="uploadAttachment" ref="upload"
                                    style="text-transform: none !important; color: #0475f3;width: 8em;">
                                    Browse
                                </file-upload>
                                <div>
                                    <p class="drag-drop text-center fs-12">
                                        Supports .jpg,.png,.pdf,.docx,.txt,.gif,.jpeg,.xls,.xlsx,.csv,.eml <br>Size limit- 25.00 MB
                                    </p>
                                </div>
                            </div>
                            <div class="p-4" v-for="(attachment,index) in attachments"
                                :key="attachment.url">
                                <span  class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                    <img class="att-img pointer" v-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.png') || attachment.name.endsWith('.gif') || attachment.name.endsWith('.jpeg')" :src="attachment.url" alt="">
                                    <img v-else-if="attachment.name.endsWith('.svg')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                    <!-- <img class="icon-img" v-else-if="attachment.name.endsWith('.jpg')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                    <img class="icon-img" v-else-if="attachment.name.endsWith('.png')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                    <img class="icon-img" v-else-if="attachment.name.endsWith('.gif')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                    <img class="icon-img" v-else-if="attachment.name.endsWith('.jpeg')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" /> -->
                                    <img class="icon-img" v-else-if="attachment.name.endsWith('.docx')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                    <img class="icon-img" v-else-if="attachment.name.endsWith('.pdf')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                    <img class="icon-img" v-else-if="attachment.name.endsWith('.xls')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                    <img class="icon-img" v-else-if="attachment.name.endsWith('.xlsx')"
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                    <img class="icon-img" v-else
                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt=""/>
                                </span>
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <img class="icon-img" v-if="attachment.name.endsWith('.jpg')"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                            <img class="icon-img" v-else-if="attachment.name.endsWith('.png')"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                            <img class="icon-img" v-else-if="attachment.name.endsWith('.gif')"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                            <img class="icon-img" v-else-if="attachment.name.endsWith('.jpeg')"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                            <img class="icon-img" v-else-if="attachment.name.endsWith('.svg')"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                            <img class="icon-img" v-else-if="attachment.name.endsWith('.docx')"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                            <img class="icon-img" v-else-if="attachment.name.endsWith('.pdf')"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                            <img class="icon-img" v-else-if="attachment.name.endsWith('.xls')"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                            <img class="icon-img" v-else-if="attachment.name.endsWith('.xlsx')"
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                            <img class="icon-img" v-else
                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt=""/>
                                        </div>
                                        <div class="col">
                                            <div class="d-flex justify-content-between">
                                                <el-tooltip :content="attachment.name" placement="top">
                                                    <div
                                                        class="font-weight-bold text-truncate d-block mx-width-220">
                                                        {{attachment.name}}</div>
                                                </el-tooltip>
                                            </div>
                                            <div v-if="attachment.uploading || attachment.url == undefined">
                                                <progress-bar class="progressBar w-100"
                                                    :class="{'error-upload':attachment.url == undefined}"
                                                    :val="attachment.progress" size="small"></progress-bar>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="text-danger pl-0 fw-500"
                                                    v-if="attachment.error != ''">{{attachment.error}}...
                                                </div>
                                                <div class="text-secondary fw-500"
                                                    v-if="attachment.progress<100 && attachment.error == ''">
                                                    {{attachment.progress}}% Uploaded</div>
                                                <div class="fw-500">({{attachment.size | prettyBytes}})
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="pointer">
                                            <a class="pointer" :href="attachment.url" download style="text-decoration: none;">
                                                <i class="icon icon-download"></i>
                                            </a>
                                        </div>
                                        <div>
                                            <div v-if="attachment.uploading || attachment.url == undefined"
                                                class="pointer" @click="deleteAttachment(index)">
                                                <i class="icon icon-close fs-16 closeAttachment"></i>
                                            </div>
                                            <div v-else class="pointer" @click="deleteAttachment(index)">
                                                <i class="icon icon-close fs-16 closeAttachment"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
        <notes modal_name="notes" :note_mode="note_mode" :notes_list="campaign_info.notes" :note_index="note_index" v-if="show_notes" @hideNotes="hideNotes"></notes>
    </div>
</template>
<script>
const Preview = () => import("../../Preview");
var mime = require('mime-types')
import { SweetModal } from 'sweet-modal-vue';
import { HalfCircleSpinner } from "epic-spinners";
import campaignList from "../../mixins/campaign.js"
import axios from "axios";
const Notes = () => import("./Notes.vue")
export default {
    mixins: [campaignList],
    data(){
        return{
            callInProgress: false,
            attachments: [],
            show_notes: false,
            analytics_data: null,
            campaign_info: null,
            campaign_name: '',
            campaign_status: '',
            loader: false,
            note_mode: '',
            note_index: null,
            success_msg: '',
            warning_msg: '',
            preview_visible: false,
            preview_file: '',
        }
    },
    components: {
        Notes,
        HalfCircleSpinner,
        SweetModal,
        Preview
    },
    methods: {
        hidePreview(){
            this.preview_visible = false
        },
        previewImage(file) {
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            this.preview_visible = true;
        },
        addNotes(note_index){
            if(this.campaign_info.notes.length < 10){
                if(note_index != null){
                    this.note_mode = 'edit'
                } else{
                    this.note_mode = 'add'
                }
                this.note_index = note_index
                this.show_notes = true
                setTimeout(() => {
                    this.$modal.show("notes")
                }, 500);
            } else {
                this.warning_msg = 'Notes Limit Exceeded'
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async deleteAttachment(index) {
            this.campaign_info.attachments.splice(index, 1)
            try{
                let params = {
                    "attachments": this.campaign_info.attachments,
                    "campaign_id": this.$route.query.campaign_id
                }
                let response = await this.saveCampaignNotes(params)
                this.success_msg = 'Attachment Deleted Successfully'
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$modal.hide(this.modal_name)
                    this.$emit("hideNotes")
                }, 2000);
            } catch(error){
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
            // if (this.attachments[index].id == '' || this.attachments[index].id == undefined || this
            //     .attachments[index].id == null) {
            //     this.attachments.splice(index, 1);
            // } else {
            //     this.attachments[index].is_delete = true;
            //     this.temp_products = [];
            //     // this.notes = [];
            //     this.temp_attachments = [];
            //     this.attachments.forEach(x => {
            //         this.temp_attachments.push(x)
            //     })
            //     this.temp_attachments.forEach(x => {
            //         delete x['created_time']
            //         delete x['error']
            //         delete x['progress']
            //         delete x['content_type']
            //         delete x['deal_id_id']
            //         delete x['uploading']
            //     })
            //     let response = await this.editDeals(this.$route.params.id, this.update_deal)
            //     this.success_msg = "Attachment Deleted Successfully"
            //     this.temp_attachments = [];
            //     this.$refs.success_modal.open();
            //     setTimeout(() => {
            //         this.$refs.success_modal.close();
            //         this.attachments = [];
            //         this.loadAttachments();
            //     }, 3000);
            // }
        },
        async deleteNotes(note_index){
            this.campaign_info.notes.splice(note_index, 1)
            try{
                let params =
                {
                    "campaign_id": this.$route.query.campaign_id,
                    "notes": this.campaign_info.notes
                }
                let response = await this.saveCampaignNotes(params)
                this.success_msg = 'Note Deleted Successfully'
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$modal.hide(this.modal_name)
                    this.$emit("hideNotes")
                }, 2000);
            }
            catch(error){
                this.disable_save = false
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        hideNotes(){
            this.show_notes = false
        },
        uploadAttachment(newFile, oldFile) {
                var input = newFile;
                if(this.attachments.map(x => x.name).includes(input.file.name)){
                    this.$toasted.global.error("This file already exists")
                } else if(!input.file.name.endsWith('.htm') && !input.file.name.endsWith('.html') && !input.file.name.endsWith('.flv')){
                    this.total_file_size = this.total_file_size + input.file.size
                    if (input.file) {
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
                        let attachment = {
                            name: input.file.name,
                            size: JSON.stringify(input.file.size),
                            source: source,
                            progress: 0,
                            created_time: new Date(),
                            error: ""
                        }
                        if (this.attachments.length >= 10) {
                            this.$toasted.global.error("you're not allowed to upload more than 10 attachments")
                            this.total_file_size = this.total_file_size - input.file.size
                        } else
                        if (this.total_file_size > 25000 * 1000){
                            this.$toasted.global.error("Attachments Size Cannot Exceed 25mb")
                            this.total_file_size = this.total_file_size - input.file.size
                        } else {
                            this.attachments.push(attachment);
                            this.getResumableURL(input.file, this.attachments[this.attachments.length - 1]);
                        }
                    }
                } else {
                    this.$toasted.global.error('This File is not supported')
                }
            },
            getResumableURL(file, attachment) {
                this.isUploadingInProgress = true;
                attachment.uploading = true;
                let data = {
                    file: attachment.name
                }
                data = new FormData()
                data.append('file', file)
                this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                        onUploadProgress: function (progressEvent) {
                            let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                                .total));
                            if (progress < 100) {
                                attachment.progress = progress;
                            }
                        }.bind(this)
                    })
                    .then(response => {
                        let resumable_url = response.data.url;
                        attachment.url = resumable_url;
                        attachment.progress = 100;
                        attachment.uploading = false;
                        this.isUploadingInProgress = false;
                        delete attachment['source'];
                        setTimeout(() => {
                            // this.saveFiles();
                            this.AddAttachments()
                        }, 500);
                    })
                    .catch(error => {
                    })
            },
            async AddAttachments(){
                let temp_attachments = [];
                this.attachments.forEach((el, el_index) => {
                    temp_attachments.push({
                        name: el.name,
                        size: el.size,
                        url: el.url
                    })
                })
                try{
                    let params = {
                        "attachments": temp_attachments,
                        "campaign_id": this.$route.query.campaign_id
                    }
                    let response = await this.saveCampaignNotes(params)
                    this.success_msg = 'Attachment Added Successfully'
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.$modal.hide(this.modal_name)
                        this.$emit("hideNotes")
                    }, 2000);
                } catch(error){
                    this.warning_msg = error
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
            async getCampaignEmailDetails(){
                this.callInProgress = true
                let params = {
                    campaign_id: this.$route.query.campaign_id,
                    type:"sms",
                    start_date: this.$route.query.start_date,
                    category_id: this.$route.query.category_id
                }
                let response = await this.getAnalyticsData(params)
                this.analytics_data = response.response
                this.NotesAttachmentsData();
                this.callInProgress = false
            },
            async NotesAttachmentsData(){
                this.loader = true
                let response = await this.getCampaignDetails(this.$route.query.campaign_id)
                this.campaign_info = response.response
                this.campaign_status = this.campaign_info.status
                this.campaign_name = this.campaign_info.name
                this.attachments = this.campaign_info.attachments
                this.loader = false
            }
    },
    mounted(){
        this.getCampaignEmailDetails()
    },
    computed:{
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        }
    }
}
</script>
<style scoped>
.sub-heading{
    background-color: rgb(0, 93, 174);
    color: rgb(255, 255, 255);
    padding: 10px 0px 1px 22px;
    border-radius: 4px 4px 0px 0px;
}
.text-color{
    color: #338DF1;
}
.email-table{
    border: 1px dotted black;
    border-radius: 6px;
    max-width: 95%;
    margin-left: 24px;
}
.border-right{
    border-right: 1px dotted black !important;
}
.today-col{
    background-color: #CCE4FC;
    /* border-radius: 10px 0px 0px 10px; */
}
.email-details-table{
    width: 100%;
}
.col-width{
    width: 10%;
}
.notes{
    box-shadow: rgb(147 147 147) 0px 0px 6px 0px;
    margin-top: 12px !important;
    margin-left: 24px;
    border-radius: 6px;
    width: 90%;
}
.text-dark-blue {
    color: #00448b;
}
.attachments-section{
    box-shadow: rgb(147 147 147) 0px 0px 6px 0px;
    margin-top: 12px !important;
    margin-left: 24px;
    border-radius: 6px;
    width: 90%;
}
.drag-drop{
    color: #ADADAD;
}
.whitespace-nowrap{
    white-space: nowrap;
}
.notes-div {
    max-height: 242px;
    min-height: 242px;
    overflow: auto;
}

.no-data{
    margin: 0 auto;
    display: block;
    text-align: center;
}
.no-data img{
    width: 250px;
}
.no-data div{
    margin-top: 10px;
    color: rgba(103, 103, 103, 0.84);
}

.overflow-auto{
    overflow: auto;
}
.mx-ht{
    max-height: 128px;
    min-height: 128px;
    /* max-height: 180px;
    min-height: 180px; */
}

.text-pending{
    color: #E4A045 !important;
}

.text-approved{
    color: #078A63 !important
}

.text-rejected{
    color: #E64646 !important
}

.block-cursor{
    cursor: not-allowed !important;
    color: #707070 !important
}
.cstm-width{
    width:150px;
}
.table-responsive-custom{
    display: flex;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Campaign/Sms/CampaignSmsDetails.vue